import { Box } from "@chakra-ui/react";
import React from "react";
import { colors } from "../../constants/design.constants";

const BasePageTitleContainer: React.FC<any> = ({ children, ...props }) => {
  return (
    <Box
      width={{ md: "100%" }}
      maxWidth={{ base: "100%", md: "640px" }}
      mt={{ base: "0", md: "24px" }}
      mx={{ base: "16px", md: "auto" }}
      p="16px 20px"
      borderRadius="2px"
      bg={colors.elevated}
      border={`1px solid ${colors.border}`}
      {...props}
    >
      <Box width="100%" height="100%">
        {children}
      </Box>
    </Box>
  );
};

export default BasePageTitleContainer;
